const storageKey = (companyId: string) => `wembii-chat-resolved:${companyId}`;

export const readLocallyResolvedIds = (companyId: string): Set<string> => {
  try {
    const raw = localStorage.getItem(storageKey(companyId));
    if (!raw) return new Set();
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.map(String));
  } catch {
    return new Set();
  }
};

export const writeLocallyResolvedIds = (
  companyId: string,
  ids: Set<string>
) => {
  localStorage.setItem(
    storageKey(companyId),
    JSON.stringify(Array.from(ids))
  );
};

export const toggleLocallyResolved = (
  companyId: string,
  conversationId: string
): boolean => {
  const ids = readLocallyResolvedIds(companyId);
  const id = String(conversationId);
  if (ids.has(id)) {
    ids.delete(id);
    writeLocallyResolvedIds(companyId, ids);
    return false;
  }
  ids.add(id);
  writeLocallyResolvedIds(companyId, ids);
  return true;
};

export const isLocallyResolved = (
  companyId: string,
  conversationId: string
) => readLocallyResolvedIds(companyId).has(String(conversationId));
